import { useAtom } from 'jotai'
import { alertAtom } from '../../common/jotaiState/globalStateAtoms'
import { useEffect, useState } from 'react'
import { focusElemnt, getFloat, navigation3 } from '../../common/helper'
import * as sx from '../../common/stylesInline/report_daily_branch'
import Datepicker from '../../common/datePicker'
import DropDownOA from '../../common/dropDownOA'
import { Item } from '../../common/snippets'
import useToken from '../../helpers/useTokens'
import { getExEntryHeaders, getSelectModeData } from './constant'
import { GetRequest, PostRequest } from '../../common/api'
import { urls } from '../../common/constants'
import moment from 'moment'
import { Box, Stack, Button } from '@mui/material'
import { RenderTable } from '../Reports/analysisReport/summmaryTable'
import LineinputV2 from '../../common/lineinputV2'
import { useTranslation } from '../../../i18n/I18nProvider'

export const ExpenseEntry = () => {
  const { translations } = useTranslation()
  const op = translations?.operationsPrivilege || {}
  const cs = translations?.common || {}
  const selectModeData = getSelectModeData(translations)
  const exEntryHeaders = getExEntryHeaders(translations)
  const { loginData } = useToken()
  const [expenseHeadList, setExpenseHeadList] = useState([])
  const [expenseSubHeadList, setExpenseSubHeadList] = useState([])
  const [, setAlert] = useAtom(alertAtom)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [selHead, setSelHead] = useState('')
  const [selSubHead, setSelSubHead] = useState('')
  const [selMode, setSelMode] = useState(selectModeData[0])
  const [expenseAmount, setExpenseAmount] = useState('')
  const [naration, setNarration] = useState('')
  const [tableData, setTableData] = useState([])
  useEffect(() => {
    if (!loginData?.intCompanyID) return
    const fetchHead = async () => {
      try {
        const obj1 = {
          intCompanyID: loginData.intCompanyID,
          intAccountHeadID: 0,
          intIsActive: 1,
        }
        const res = await GetRequest(urls.getExpenseHeadDetails + '?', obj1)
        if (res.status === 'Success') {
          setExpenseHeadList(res.Data.Table)
          setSelHead(res.Data.Table?.[0] || {})
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchHead()
  }, [loginData?.intCompanyID])
  const fetchData = async () => {
    const obj = {
      CompanyID: loginData.intCompanyID,
      BranchID: loginData.intBranchID,
      CityID: loginData.intBranchCityID,
      UserID: loginData.intUserID,
      FromDate: fromDate.format('YYYY-MM-DD'),
      ToDate: fromDate.format('YYYY-MM-DD'),
      Mode: 1,
    }
    const res = await GetRequest(urls.getExpenseEntryDetails + '?', obj)
    if (res.status === 'Success') {
      const temp = res.Data.Table1.map((item, index) => {
        return {
          ...item,
          SN: index + 1,
          action: (
            <Button
              style={{ fontSize: '1.3rem', width: '100%', height: '30px', border: '1px solid' }}
              onClick={() => handleRemove(item.ID)}
            >
              {cs.remove || 'Remove'}
            </Button>
          ),
        }
      })
      setTableData(temp)
    }
  }
  useEffect(() => {
    fetchData()
  }, [fromDate])
  const handleRemove = (AccountID) => {
    const obj = {
      AccountID,
    }
    PostRequest(urls.expenseEntryRemoveUpdate, obj).then((res) => {
      if (res.status === 'Success') {
        fetchData()
        setAlert({ show: true, success: true, msg: op.expenseEntryRemovedSuccessfully || 'Expense Entry removed successfully', nextId: '' })
      } else {
        setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
      }
    })
  }
  useEffect(() => {
    if (!selHead?.AccountHeadID) return
    const fetchSubHead = async () => {
      try {
        const obj = {
          intCompanyID: loginData.intCompanyID,
          intAccountHeadID: selHead.AccountHeadID,
          intAccountSubHeadID: 0,
          intIsActive: 1,
        }
        const res = await GetRequest(urls.getExpenseSubHeadDetails + '?', obj)
        if (res.status === 'Success') {
          setExpenseSubHeadList(res.Data.Table)
          setSelSubHead(res.Data.Table?.[0] || {})
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchSubHead()
  }, [selHead])
  const handleAdd = () => {
    if (!selHead.AccountHeadID) {
      setAlert({ show: true, msg: op.pleaseSelectHead || 'Please Select Head', nextId: 'accountHead' })
    } else if (!selSubHead.AccountSubHeadID) {
      setAlert({ show: true, msg: op.pleaseSelectSubHead || 'Please Select SubHead', nextId: 'accountSubHead' })
    } else if (!selMode.id) {
      setAlert({ show: true, msg: op.pleaseSelectMode || 'Please Select Mode', nextId: 'selectMode' })
    } else if (!expenseAmount) {
      setAlert({ show: true, msg: op.pleaseEnterExpenseAmount || 'Please Enter Expense Amount', nextId: 'expenseAmount' })
    } else if (!naration) {
      setAlert({ show: true, msg: op.pleaseEnterNaration || 'Please Enter Naration', nextId: 'narationID' })
    } else {
      const obj = {
        intCompanyID: loginData.intCompanyID,
        intLoginBranchID: loginData.intBranchID,
        intLoginUserID: loginData.intUserID,
        EntryDateTime: fromDate.format('YYYY-MM-DD'),
        AccountHeadID: selHead.AccountHeadID,
        AccountSubHeadID: selSubHead.AccountSubHeadID,
        Mode: selMode.apiValue,
        ExpenseAmount: Number(expenseAmount),
        Narration: naration,
      }
      PostRequest(urls.expenseEntryUpdate, obj).then((res) => {
        if (res.status === 'Success') {
          fetchData()
          setAlert({ show: true, success: true, msg: op.expenseEntryAddedSuccessfully || 'Expense Entry Added successfully', nextId: '', close: clarFileds })
        } else {
          setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
        }
      })
    }
  }
  const clarFileds = () => {
    setNarration('')
    setExpenseAmount('')
    setAlert({ show: false, success: false, msg: '', nextId: '' })
  }
  const handleSave = () => {
    const AccountIDs = tableData.map((item) => item.ID).join('^')
    const obj = {
      AccountIDs,
    }
    PostRequest(urls.expenseEntrySaveUpdate, obj).then((res) => {
      if (res.status === 'Success') {
        fetchData()
        setAlert({ show: true, success: true, msg: op.expenseEntrySavedSuccessfully || 'Expense Entry Saved successfully', nextId: '' })
      } else {
        setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
      }
    })
  }
  return (
    <Box>
      <Stack direction="row" flexWrap="wrap" sx={{ padding: '10px 0', gap: '10px' }}>
        <Item sx={{ width: '18%', ...sx.itemsx }} className="input--container bookingDatePicker">
          <Datepicker
            label={op.selectExpenseDate || 'Select Expense Date'}
            id={'fromDateId'}
            dateChange={(date) => {
              setFromDate(date)
              focusElemnt('accountHead')
            }}
            width="100%"
          />
        </Item>

        <Item sx={{ width: '25%', ...sx.itemsxGrow }}>
          <DropDownOA
            id={'accountHead'}
            nextId={'accountSubHead'}
            prevId={'fromDateId'}
            data={expenseHeadList || []}
            defaultvalue={selHead?.HeadName || ''}
            width="100%"
            searchPlaceholder={op.selectHead || 'Select Head'}
            label={op.selectHead || 'Select Head'}
            isObjArr={true}
            dataKey="HeadName"
            idKey="AccountHeadID"
            tabIndex="5"
            onSelect={(e) => {
              setSelHead(e)
              setExpenseAmount('')
              setNarration('')
            }}
          />
        </Item>

        <Item sx={{ width: '25%', ...sx.itemsxGrow }}>
          <DropDownOA
            id={'accountSubHead'}
            nextId={'selectMode'}
            prevId={'accountHead'}
            type ={'set_default'}
            defaultvalue={selSubHead?.SubHeadName || ''}
            value={selSubHead?.SubHeadName || ''}
            data={expenseSubHeadList || []}
            width="100%"
            searchPlaceholder={op.selectSubHead || 'Select Sub Head'}
            label={op.selectSubHead || 'Select Sub Head'}
            isObjArr={true}
            dataKey="SubHeadName"
            idKey="AccountSubHeadID"
            tabIndex="5"
            onSelect={(e) => {
              setSelSubHead(e)
              setExpenseAmount('')
              setNarration('')
            }}
          />
        </Item>

        <Item sx={{ width: '22%', ...sx.itemsx }}>
          <DropDownOA
            id="selectMode"
            nextId="expenseAmount"
            prevId="accountSubHead"
            data={selectModeData}
            defaultvalue={selMode.name || ''}
            width="100%"
            searchPlaceholder={op.selectMode || 'Select Mode'}
            label={op.selectMode || 'Select Mode'}
            isObjArr={true}
            dataKey="name"
            idKey="id"
            tabIndex="6"
            onSelect={(e) => {
              setSelMode(e)
              setExpenseAmount('')
              setNarration('')
            }}
          />
        </Item>
        <Item sx={{ width: '18%', ...sx.itemsx }}>
          <div className="input--wrapper" style={{ marginBottom: '0px', width: '100%' }}>
            <LineinputV2
              id={'expenseAmount'}
              type="text"
              label={op.expenseAmount || 'Expense Amount'}
              searchPlaceholder={op.expenseAmount || 'Expense Amount'}
              value={expenseAmount}
              filter={getFloat}
              onBlur={(e) => setExpenseAmount(e.target.value)}
              onKeyDown={(e) => navigation3(e, 'narationID', 'selectMode')}
            />
          </div>
        </Item>
        <Item sx={{ width: '16%', ...sx.itemsxGrow }}>
          <div className="input--wrapper" style={{ marginBottom: '0px', width: '100%' }}>
            <LineinputV2
              id={'narationID'}
              type="text"
              label={op.narration || 'Narration'}
              searchPlaceholder={op.narration || 'Narration'}
              value={naration}
              onBlur={(e) => setNarration(e.target.value)}
              onKeyDown={(e) => navigation3(e, 'addBtn', 'expenseAmount')}
            />
          </div>
        </Item>
        <Item sx={{ width: '16%', ...sx.itemsx }}>
          <Button
            id="addBtn"
            className="select-lr-btn"
            variant="contained"
            color="error"
            style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
            onClick={() => handleAdd()}
            onKeyDown={(e) => navigation3(e, 'saveBtn', 'narationID')}
          >
            {op.add || 'Add'}
          </Button>
        </Item>
      </Stack>
      {tableData.length > 0 ? (
        <>
          <RenderTable
            data={tableData}
            header={exEntryHeaders}
            key1="ef4wd"
            key2="wdsw30"
            key3="0d3a3"
            tableStyle={{ marginBottom: '100px' }}
          />
          <Box className="bottom-floating">
            <Stack direction={'row'} justifyContent={'flex-end'} flexWrap="wrap" sx={{ padding: '10px 0', gap: '10px' }}>
              <Item sx={{ width: '16%', ...sx.itemsx }}>
                <Button
                  id="saveBtn"
                  variant="contained"
                  color="error"
                  style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
                  onClick={() => handleSave()}
                  onKeyDown={(e) => navigation3(e, 'fromDateId', 'addBtn')}
                >
                  {cs.save || 'Save'}
                </Button>
              </Item>
            </Stack>
          </Box>
        </>
      ) : (
        <></>
      )}
    </Box>
  )
}
